import React from "react";
import AdminComponent from "../../components/Admin";

export default function AdminPage() {
    return <AdminComponent />;
}
